import React from 'react'
import { Row, Col, FormGroup, Label } from 'reactstrap'
import moment from 'moment'

interface NetSuiteAssetDetailProps {
  subscriptionExpirationDate?: string
  productName: string
  subscriptionStartDate?: string
}

const NetSuiteAssetDetail: React.FC<NetSuiteAssetDetailProps> = ({
  subscriptionExpirationDate,
  productName,
  subscriptionStartDate,
}) => {
  const startDate = !subscriptionStartDate
    ? ''
    : moment(subscriptionStartDate).format('MMMM DD, YYYY')
  const expiration = !subscriptionExpirationDate
    ? ''
    : moment(subscriptionExpirationDate).format('MMMM DD, YYYY')

  return (
    <Row>
      <Col sm={6}>
        <FormGroup>
          <Label className="clearfix">Product</Label>
          <div className="form-value">{productName}</div>
        </FormGroup>
      </Col>
      <Col sm={3} xs={6}>
        <FormGroup>
          <Label className="clearfix">Start Date</Label>
          <div className="form-value">{startDate}</div>
        </FormGroup>
      </Col>
      <Col sm={3} xs={6}>
        <FormGroup>
          <Label className="clearfix">Expiration Date</Label>
          <div className="form-value">{expiration}</div>
        </FormGroup>
      </Col>
      <style>
        {`
          .form-value {
            margin-left: 1rem;
          }
        `}
      </style>
    </Row>
  )
}

export default NetSuiteAssetDetail
